import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import { orderData } from "../pre-built/orders/OrderData";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";
import { getDateStructured } from "../../utils/Utils";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom/cjs/react-router-dom";

const ProposersList = () => {
  const { errors, register, handleSubmit } = useForm();

  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const history = useHistory();

  const [view, setView] = useState({
    add: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);

  var userData = JSON.parse(localStorage.getItem('userData'));
  const role = userData?.[0]?.role;
  

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        // return item.fullname.includes(onSearchText);
        return item.fullname.toLowerCase().includes(onSearchText.toLowerCase())
      });
      setData(filteredObject);
    } else {
        axios.post(`${API_URL}getproposer`).then((result)=>
        {
            console.log(result.data);
            setData(result.data);
            getLoading(false);
        })
    }
  }, [onSearchText , refresh]);

  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  // selects all the order
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // selects one order
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setData([...newData]);
  };

 
  const onFormSubmit = (form) => {
    
    const { city, customer, email_id, phone_no, pincode, address, aad_address } = form;

    const formdata = new FormData() 
    formdata.append('city' , city);
    formdata.append('customer' , customer);
    formdata.append('email_id' , email_id);
    formdata.append('phone_no' , phone_no);
    formdata.append('pincode' , pincode);
    formdata.append('address' , address);
    formdata.append('aad_address' , aad_address);

    setLoading(true);


    axios.post( `${API_URL}addproposer`, formdata)
    .then((response)=>{
        console.log(response.data);
        if(response.data.status === 1){
            setLoading(false);
            setRefresh(true);
            onFormCancel();
            history.push('/proposers');
        }else{
            setLoading(false);
            alert(response.data.msg);
        }
    })
  };

  // function to load detail data
  const loadDetail = (id) => {
    let index = data.findIndex((item) => item.id === id);
    setFormData(data[index]);
  };

  // OnChange function to get the input data
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, details: false });
  };

  // function to change to approve property for an item
  const markAsDelivered = (id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].status = "Delivered";
    setData([...newData]);
  };

  // function to delete a Order
  const deleteOrder = (id) => {
    
    axios.get(`${API_URL}deleteproposer/${id}`).then((result)=>
    {
        console.log(result.data);
        setRefresh(true);
    })

  };

  // function to delete the seletected item
  const selectorDeleteOrder = () => {
    let newData;
    newData = data.filter((item) => item.check !== true);
    setData([...newData]);
  };

  // function to change the complete property of an item
  const selectorMarkAsDelivered = () => {
    let newData;
    newData = data.map((item) => {
      if (item.check === true) item.status = "Delivered";
      return item;
    });
    setData([...newData]);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  return (
    <React.Fragment>
      <Head title="Proposers"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Proposers</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by User Name"
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          toggle("add");
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Proposers</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              
              <DataTableRow>
                <span className="sub-text">User Name</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Email</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">Phone</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">Status</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">City</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Pincode</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Correspondence Address</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Aadhaar Address</span>
              </DataTableRow>
              <DataTableRow className="text-right">
                <span className="sub-text">Action</span>
              </DataTableRow>

            </DataTableHead>

            {currentItems.length > 0
              ? currentItems.map((item) => (
                  <DataTableItem key={item.id}>
                    
                    <DataTableRow>
                    {item.fullname}
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span>{item.email}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.phone}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span
                        className={`dot bg-${item.status === 1 ? "success" : "warning"} d-mb-none`}
                      ></span>
                      <span
                        className={`badge badge-sm badge-dot has-bg badge-${
                          item.status === 1 ? "success" : "warning"
                        } d-none d-mb-inline-flex`}
                      >
                        {item.status === 1 ? "Active" : "Inactive" }
                      </span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.city}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.pincode}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-lead">{item.address}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-lead">{item.aadhaar_address}</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                              <Icon name="more-h"></Icon>
                            </DropdownToggle>
                            <DropdownMenu right>
                              <ul className="link-list-opt no-bdr">
                                
                                {
                                  role === 1 &&(
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdown"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            deleteOrder(item.id);
                                          }}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete</span>
                                        </DropdownItem>
                                      </li>
                                  )
                                }
                                
                                <li>
                                  <Link to={`/upload_docs/${item.id}`}> <Icon name="file"></Icon> <span>Upload Docs</span> </Link>
                                  <Link to={`/user_comparison/${item.id}`}> <Icon name="file"></Icon> <span>Comparison Chart</span> </Link>
                                </li>
                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                ))
              : null}
          </div>
          <PreviewAltCard>
            {data.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No orders found</span>
              </div>
            )}
          </PreviewAltCard>
        </Block>

        <Modal isOpen={view.add} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Proposers</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Customer Name
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="customer"
                            onChange={(e) => onInputChange(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                            defaultValue={formData.customer}
                          />
                          {errors.customer && <span className="invalid">{errors.customer.message}</span>}
                        </div>
                      </div>
                    </Col>
            
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email_id">
                          Email
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="email_id"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.email_id}
                          />
                          {errors.email_id && <span className="invalid">{errors.email_id.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="phone_no">
                          Phone Number
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="phone_no"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.phone_no}
                          />
                          {errors.phone_no && <span className="invalid">{errors.phone_no.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="city">
                          City
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.city}
                          />
                          {errors.city && <span className="invalid">{errors.city.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="pincode">
                          Pincode
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            ref={register({ required: "This is required" })}
                            defaultValue={formData.pincode}
                          />
                          {errors.pincode && <span className="invalid">{errors.pincode.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="address">
                        Correspondence Address
                        </label>
                        <div className="form-control-wrap">
                          <textarea className="form-control" name="address" defaultValue={formData.address} ref={register({ required: "This is required" })}></textarea>
                          {errors.address && <span className="invalid">{errors.address.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="aad_address">
                        Aadhaar Address
                        </label>
                        <div className="form-control-wrap">
                          <textarea className="form-control" name="aad_address" defaultValue={formData.aad_address} ref={register({ required: "This is required" })}></textarea>
                          {errors.aad_address && <span className="invalid">{errors.aad_address.message}</span>}
                        </div>
                      </div>
                    </Col>


                    <Col size="12">
                      <Button color="primary" disabled={loading} type="submit">
                        <Icon className="plus"></Icon>
                        <span>{loading ? 'Loading...' : 'Add Proposers'}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.details} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="nk-tnx-details mt-sm-3">
              <div className="nk-modal-head mb-3">
                <h5 className="title">Order Details</h5>
              </div>
              <Row className="gy-3">
                <Col lg={6}>
                  <span className="sub-text">Order Id</span>
                  <span className="caption-text">{formData.orderId}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Status</span>
                  <span
                    className={`dot bg-${formData.status === "Delivered" ? "success" : "warning"} d-mb-none`}
                  ></span>
                  <span
                    className={`badge badge-sm badge-dot has-bg badge-${
                      formData.status === "Delivered" ? "success" : "warning"
                    } d-none d-mb-inline-flex`}
                  >
                    {formData.status}
                  </span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Customer</span>
                  <span className="caption-text">{formData.customer}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Purchased Product</span>
                  <span className="caption-text">{formData.purchased}</span>
                </Col>
                <Col lg={6}>
                  <span className="sub-text">Total Price</span>
                  <span className="caption-text">{formData.total}</span>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default ProposersList;
